import { render, staticRenderFns } from "./LivePayoffProfile.vue?vue&type=template&id=37db7418&"
import script from "./LivePayoffProfile.vue?vue&type=script&lang=js&"
export * from "./LivePayoffProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports